<template>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
      <Calendar numpickers=2></Calendar>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 order-xl-first">
      <ConsumptionComparison></ConsumptionComparison>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9">
      <ProdConsBars></ProdConsBars>
    </div>  
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9">
      <EnergyUsageBars></EnergyUsageBars>
    </div>  
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9">
      <ConsumptionDetailsComparison></ConsumptionDetailsComparison>
    </div>  
  </div>
</template>

<script>
import Calendar from './Calendar.vue'
import ConsumptionComparison from './ConsumptionComparison.vue'
import ProdConsBars from './ProdConsBars.vue'
import EnergyUsageBars from './EnergyUsageBars.vue'
import ConsumptionDetailsComparison from './ConsumptionDetailsComparison.vue'

export default {
  name: 'Comparison',
  components: {
    ConsumptionComparison,
    ProdConsBars,
    ConsumptionDetailsComparison,
    EnergyUsageBars,
    Calendar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
